import styled from 'styled-components';
import { BodyRegularS, DefaultInput } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

export const GoToPageCont = styled.form`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const GoToTitle = styled(BodyRegularS)`
  margin: 0 16px 0 0;
`;

interface IGoToInput {
  theme: ITheme;
  error?: string;
}

export const GoToInput = styled(DefaultInput)<IGoToInput>`
  height: 48px;
  width: 80px;
  align-items: center;
  ${({ theme }: IGoToInput) => `
      border: 1px solid ${theme.colors.neutral.primary[10]};
      border-radius: 8px; 
      padding: 12px;
      margin: 0 16px 0 0;
  `}
`;

export const GoToButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  cursor: pointer;
  border-radius: 6px;
  text-transform: capitalize;
  font-weight: 700;
  line-height: 19px;
  width: 52px;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    border: 2px solid ${theme.colors.primary[70]};
    padding: 14px ${theme.layout.spacing.centy};
    font-size: ${theme.typography.sizes.mili};

    &:hover {
      background: ${theme.colors.primary[10]};
    }
`}
`;
